(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
		name: 'DestinationGuideFilter',
	};

	var $modal = $('.modal');

	$(document).ready(function documentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function success(response)
	{
		$modal.find('.dg-filter-clear').on('click', function _clearSearch(e) {
			e.preventDefault();

			Adzuki.Ajax.get('/LivePlanner/sessionLibraryDestinationGuides/1')
			.then(function _showFilterForm(html) {
				$modal.find('.destination-guides-contents').html(html);
				Adzuki.Form.initAjaxForm('DestinationGuideFilter');
			});
		});
	};

	form.success = function success(response)
	{
		if (Adzuki.Form.hasError(response)) {
			return false;
		}

		Adzuki.Ajax.get('/LivePlanner/sessionLibraryDestinationGuides/')
		.then(function _showFilterForm(html) {
			$modal.find('.destination-guides-contents').html(html);
			Adzuki.Form.initAjaxForm('DestinationGuideFilter');
		});
	};
}(jQuery, window.Adzuki || {}));